module.exports = __webpack_public_path__ + "./docs/img/big-icon-ref_folder.7486f492c3d1872af7ee5e35f3bd9dcf.svg";